import common from "../common";
import Scene from "./Scene";
import SecondaryButton from "../ui/SecondaryButton";

export default class PreloaderScene extends Scene {
    constructor()
    {
        super('preloader');

        this.images = [
            'btn_sound_off.png',
            'btn_sound_on.png',
            'icon_dropdown.png',
            'icon_dropup.png',
            'ui_logo_world_united.png',
            'ui_logo_1goal_0emissions.png',
            'ui_logo_gogreen.png',
            'ui_icon_error.png',
        ];
        this.json = [
            'questions.json',
            'strings.json',
            'areacodes.json',
            'settings.json',
            'countryTranslations.json'
        ];
        this.sounds = [
            {id:'music_question_loop_00', loop:true},
            {id:'music_question_loop_simple_00', loop:true},
            {id:'music_question_loop_simple_01', loop:true},
            {id:'music_result_loop_00', loop:true},
            {id:'music_splash_loop_00', loop:true},
            {id:'music_sting_wooh_00', loop:false},
            {id:'music_sting_woah_00', loop:false},
            {id:'sfx_ball_bounce_1', loop:false},
            {id:'sfx_ball_bounce_2', loop:false},
            {id:'sfx_ball_bounce_3', loop:false},
            {id:'sfx_ball_bounce_4', loop:false},
            {id:'sfx_ball_kick', loop:false},
            {id:'sfx_ball_kick', loop:false},
            {id:'sfx_crowd_ambient_loop_00', loop:true},
            {id:'sfx_crowd_ambient_loop_01', loop:true},
            {id:'sfx_crowd_roar_layer_01', loop:false},
            {id:'sfx_crowd_roar_layer_02', loop:false},
            {id:'sfx_crowd_roar_layer_03', loop:false}
        ];
        this.loadCount = 0;
        this.totalCount = 0;

        this.contentShown = false;

        this.loadingBar = null;

        this.hasLoaded = false;
    }

    init()
    {
        super.init();

        this.addContentHolder(false);
        this.holder.addClass('p3-preloaderBG');

        this.totalCount = this.images.length + this.json.length;

	    if(this.totalCount === 0)
	    {
	        this.onAllFilesLoaded();
	    }

	    for(var i in this.images)
	    {
	    	this.images[i] = common.baseUrl + 'assets/images/' + this.images[i];
        }
        for(var i in this.json)
	    {
            this.json[i] = common.baseUrl + 'config/' + this.json[i];
        }

        $.each(this.images, function(index, image)
        {
            $('<img>').attr('src', image).on('load', this.onFileLoaded.bind(this));
        }.bind(this));
        $.each(this.json, (index, file) =>
        {
            $.ajax({
                url: file,
                success: (result) => 
                {
                    common.config[file.replace('.json', '').replace(common.baseUrl + 'config/', '')] = result;
                    this.onFileLoaded(); 
                },
                error: (error) =>
                {
                    console.error('Error parsing ' + file + ': ' + error);
                }
            });
        });

        if(!common.basicMode)
        {
            var formats = ['mp4', 'mp3', 'ogg'];

            for(var i in this.sounds)
            {
                var arr = [];
                for(var j in formats)
                {
                    arr.push(common.baseUrl + 'assets/audio/' + this.sounds[i].id + '.' + formats[j]);
                }
                this.sounds[i].url = arr;
            }
            common.soundManager.loadSounds(this.sounds);
        }
    }

    postInit()
    {
        super.postInit();
    }

    update(dt)
    {
        if(this.loadCount === this.totalCount && (common.basicMode || MEDIATOR.pcApp != null) )
    	{
    		this.onAllFilesLoaded();
        }
        
        this.loadTime += dt;
    }

    showContent()
    {
        if(this.contentShown)
            return;

        this.contentShown = true;

        var takeYourSeat = $('<div style="position:absolute; width:100%; text-align:center; top:40%; font-size:8vh; font-family:\'Delivery Condensed Black\'">' + common.config.strings.take_your_seat[common.country].toUpperCase() + '</div>')
        this.holder.append(takeYourSeat);
        
        var loading = $('<div style="position:absolute; width:100%; text-align:center; top:60%; font-size:4vh; font-family:\'Delivery Condensed Black\'">' + common.config.strings.loading[common.country].toUpperCase() + '</div>')
        this.holder.append(loading);

        if(!common.basicMode)
        {
            var basicHolder = $('<div id="p3-basic-button-holder"></div>');
            $('#game').append(basicHolder);
            common.basicButton = new SecondaryButton(common.config.strings.basic_form[common.country]);
            basicHolder.append(common.basicButton.htmlElement);
    
            common.basicButton.signals.up.add(() => {
                MEDIATOR.redirectToBasicMode();
            });
            common.basicButton.htmlElement.hide();

            setTimeout(() => 
            {    
                if(!this.hasLoaded)
                {
                    common.basicButton.htmlElement.show();
                }
            }, 40000)
        }
    }

    onFileLoaded()
    {
        this.loadCount++;
        
        if(common.config.strings)
        {
            this.showContent();
        }
        
    }

    onAllFilesLoaded()
    {
        this.hasLoaded = true;
        console.log(common.data);
        this.signals.next.dispatch();
        if(common.basicButton)
        {
            common.basicButton.htmlElement.show();
        }

        for(var i in common.config.questions)
        {
            if(common.config.questions[i].id == "country")
            {
                for(var j in common.config.questions[i].fields)
                {
                    if(common.config.questions[i].fields[j].id == "country")
                    {
                        var countries = common.config.questions[i].fields[j].options;
                        var list = common.config.countryTranslations[common.country];
                        if(list)
                        {
                            for(var k in countries)
                            {
                                countries[k].name = list[countries[k].value.toUpperCase()];
                            }
                            countries.sort((a, b) => {
                                if(a.name > b.name)
                                    return 1;
                                else if(a.name < b.name)
                                    return -1;
                                return 0;
                            });
                        }
                        
                    }
                }
            }
        }
    }
}